import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import TabContext from '../TabContext';

import styles from './Tab.scss';

function Tab(props) {
    const {
        activeClassName,
        className,
        children,
        id,
    } = props;

    return (
        <TabContext.Consumer>
            {({ activeId, onChange }) => (
                <li
                    aria-controls={`panel-${id}`}
                    aria-selected={activeId === id}
                    className={classNames(
                        className,
                        styles.tab,
                        { [styles.active]: activeId === id },
                        { [activeClassName]: activeId === id },
                    )}
                    id={`tab-${id}`}
                    onClick={() => (activeId !== id) && onChange(id)}
                    role="tab"
                >
                    {children}
                </li>
            )}
        </TabContext.Consumer>
    );
}

Tab.propTypes = {
    activeClassName: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};

export default Tab;
